import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  constructor() { }

  ngOnInit(): void {
  }

  closeModal(){
    // alert('yes');
    this.closebutton.nativeElement.click();
  }

}
